import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { SortingDirection } from '../../../../../../__legacy__/models/sortingDirection.model';
import { IProjectStatsFiltersStore } from '../../filters/ProjectStatsFilters.store';
import { IProjectStatsBl } from '../../ProjectStats.bl';
import { IProjectStatsStore } from '../../ProjectStats.store';
import { AnnotationToolsStatsTable } from './AnnotationToolsStatsTable';

export const AnnotationToolsStatsTableContainer = observer((): ReactElement => {
  const bl = useInjection(IProjectStatsBl.$);
  const filtersStore = useInjection(IProjectStatsFiltersStore.$);
  const store = useInjection(IProjectStatsStore.$);

  const handleOnSortChange = (orderBy: string, orderDirection: SortingDirection | undefined): void => {
    bl.changeAnnotationToolsStatsSorting(orderBy, orderDirection ?? SortingDirection.ASC);
  };

  const { visibleWorkers } = filtersStore;
  const { annotationToolsStats } = store;

  const items = annotationToolsStats.filter((s) => visibleWorkers.map((w) => w.id).includes(s.id));

  return (
    <AnnotationToolsStatsTable
      items={items}
      orderBy={store.annotationToolsStatsOrderBy}
      orderDirection={store.annotationToolsStatsOrderDirection}
      onSortChange={handleOnSortChange}
    />
  );
});
